import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Container, Row, InputGroup } from 'react-bootstrap'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { BiUser } from "react-icons/bi";
import { config } from '../Components/CommonUtilities/CommonUrl/CommonUrls';
import axios from 'axios';
import { TfiReload } from 'react-icons/tfi';
import Sweetalert, { SweetalertHtml } from '../Components/CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import LoginTemplate from './loginTemplate';
import { CommomLoginAunthenticatePost } from '../Components/CommonUtilities/CommonAxios/CommonAxios';
import { AADHAR_VALIDATION, Aadhaar_Msg, ERROR_MSG, MOBILE_VALIDATION, Mobile_Msg, handleKeyPressNumeric } from '../Components/CommonUtilities/Validations/RegularExpAndVar';
import Swal from 'sweetalert2';

  export const userValidationSchema_know = Yup.object().shape({
        aadhaarNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, Aadhaar_Msg),
        // mobile: Yup.string().required(ERROR_MSG).nullable().matches(MOBILE_VALIDATION, Mobile_Msg),
        captcha: Yup.string().required(ERROR_MSG),

    });
export default function KnowUserId() {

    
    /************    HIT TO LOGIN DETAILS API AND SEND TOKEN SET DETAILS ************/
    const submitDetails = async (values, { resetForm }) => {
        let url = config.url.CONTEXT_URL + "kgbv-public/know-candidate"
        CommomLoginAunthenticatePost(url, values).then((res) => {
            if (res?.data?.status === true) {
                setCandidId(res?.data?.data[0]?.candidate_id)
                let htmltext = `Your Candidate Id is <span style="color: blue;">${res.data.data[0]?.candidate_id}</span>`
                Swal.fire({
                    html: htmltext,
                    icon: "success",
                    backdrop: false,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Click Here to login",
                }).then((update) => {
                    if (update.isConfirmed) {
                        window.location.href = "/";
                    }
                })
                resetForm()

            } else {
                handleRefreshCaptcha()
                Sweetalert('Invalid Credentials', "error")
            }
        })

    }
 
    const formIk = useFormik({
        initialValues: {
            "aadhaarNo": "",
            "mobile": "",
            "captcha": "",
            "captchaId": ""
        },
        validationSchema: userValidationSchema_know,
        onSubmit: submitDetails,
    });
    document.body.classList.add(
        'jnb-bg'
    );
    const [refreshCaptcha, setRefreshCaptcha] = useState("");
    const [candidId, setCandidId] = useState("")
    const handleRefreshCaptcha = () => {
        formIk.setFieldValue('captchaId', "")
        formIk.setFieldValue('captcha', "")
        let url = config.url.CONTEXT_URL + "kgbv-public/generate-captcha";
        axios.post(url).then((res) => {
            if (res?.data?.status === true) {
                setRefreshCaptcha(res.data.captcha)
                formIk.setFieldValue('captchaId', res.data.captchaId)
            }
        })
    };

    useEffect(() => { handleRefreshCaptcha() }, [])
    return (
        <FormikProvider value={formIk}>

            <div className='section'>
                <Container fluid>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className='nyay-right-part p-0'>
                            <div className='nyay-login-page'>
                                <h4>Know User Id</h4>

                                <p className='pt-1 pt-md-2'>Hello ! Your Candidate ID is <b className='text-primary'> {candidId}</b>  </p>
                                <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit} className='nyay-form mt-4 mt-md-5'>

                                    <InputGroup className="mb-3">
                                        <InputGroup.Text id="basic-addon1" className="group_txt">
                                            <BiUser className="font_size" />
                                        </InputGroup.Text>
                                        <Field
                                            type="text"
                                            name="aadhaarNo"
                                            placeholder="Enter Your Aadhaar No."
                                            className="input-field form-control"
                                            maxLength='12'
                                            onKeyPress={(e) => { handleKeyPressNumeric(e); }}
                                        />
                                        <ErrorMessage
                                            name="aadhaarNo"
                                            component="div"
                                            className="text-error"
                                        />
                                    </InputGroup>

                                    {/* <InputGroup className="mb-3">
                                        <InputGroup.Text id="basic-addon1" className="group_txt">
                                            <BiUser className="font_size" />
                                        </InputGroup.Text>
                                        <Field
                                            type="text"
                                            name="mobile"
                                            placeholder="Enter Your Mobile No."
                                            className="input-field form-control"
                                            maxLength='10'
                                            onKeyPress={(e) => { handleKeyPressNumeric(e); }}

                                        />
                                        <ErrorMessage
                                            name="mobile"
                                            component="div"
                                            className="text-error"
                                        />
                                    </InputGroup> */}
                                    <InputGroup className="mb-2">
                                        <TfiReload onClick={() => { handleRefreshCaptcha() }} size={20} className="mt-2" />&nbsp;
                                        <img height={40} width={100} src={refreshCaptcha} alt="captcha" />
                                        &nbsp;&nbsp;<Field
                                            className="form-control"
                                            type="text"
                                            name="captcha"
                                            placeholder="Captcha"
                                            maxLength="6"
                                            autoComplete="off"
                                        />
                                    </InputGroup>
                                    <ErrorMessage
                                        name="captcha"
                                        component="div"
                                        className="text-error"
                                    />
                                    <Button variant="" type="submit" className='w-100 sign-in-button' >
                                        Submit
                                    </Button>
                                </Form>
                                <div className='forget-password text-end mt-2'>
                                    <a href='/ForgotPassword'>Forgot Password?</a><br />
                    
                                </div>
                            </div>
                        </Col>
                             <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12} className='nyay-left-part'>
                                                                 <div className="teachers-all me-lg-5 ms-lg-3">
                                                                   <h1>AP KGBV RECRUITMENT
                                                                     </h1>
                                                                   <p>Kasturba Gandhi Balika Vidyalayas (KGBVs) are the residential schools for girls setup in educationally backward blocks to ensure access and quality education to 
                                                                   girls from disadvantaged and underprivileged sections of the society. They run from classes VI to XII.</p>
                                                                 </div>
                                                               
                        </Col>
                    </Row>
                </Container>
            </div>

        </FormikProvider>
    )
}
export const KnowUser=(props)=>{
    const{formIk, handleRefreshCaptcha ,refreshCaptcha}=props;
    return(<>
    
        <FormikProvider value={formIk}>
         <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit} className='nyay-form mt-4 mt-md-5'>
<Row>
    <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
 <InputGroup className="mb-3">
                                        <InputGroup.Text id="basic-addon1" className="group_txt">
                                            <BiUser className="font_size" />
                                        </InputGroup.Text>
                                        <Field
                                            type="text"
                                            name="aadhaarNo"
                                            placeholder="Enter Your Aadhaar No."
                                            className="input-field form-control"
                                            maxLength='12'
                                            onKeyPress={(e) => { handleKeyPressNumeric(e); }}
                                        />
                                        <ErrorMessage
                                            name="aadhaarNo"
                                            component="div"
                                            className="text-error"
                                        />
                                    </InputGroup>
    </Col>
    <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
         <InputGroup className="mb-2">
                                        <TfiReload onClick={() => { handleRefreshCaptcha() }} size={20} className="mt-2" />&nbsp;
                                        <img height={40} width={100} src={refreshCaptcha} alt="captcha" />
                                        &nbsp;&nbsp;<Field
                                            className="form-control"
                                            type="text"
                                            name="captcha"
                                            placeholder="Captcha"
                                            maxLength="6"
                                            autoComplete="off"
                                        />
                                    </InputGroup>
                                    <ErrorMessage
                                        name="captcha"
                                        component="div"
                                        className="text-error"
                                    />
    </Col>
</Row>
                                   

                                    {/* <InputGroup className="mb-3">
                                        <InputGroup.Text id="basic-addon1" className="group_txt">
                                            <BiUser className="font_size" />
                                        </InputGroup.Text>
                                        <Field
                                            type="text"
                                            name="mobile"
                                            placeholder="Enter Your Mobile No."
                                            className="input-field form-control"
                                            maxLength='10'
                                            onKeyPress={(e) => { handleKeyPressNumeric(e); }}

                                        />
                                        <ErrorMessage
                                            name="mobile"
                                            component="div"
                                            className="text-error"
                                        />
                                    </InputGroup> */}
                                   
                                   
                                </Form>
                                </FormikProvider>
    </>)

}
